import AvatarStyles from "../Styles/AvatarStyles";
export default function Avatar()
{ const classes = AvatarStyles();
  return ( <div className={classes.Avatar}> <img src="Pics/Logos/logo30x30.png" alt="Avatar"></img> </div> 
         ); 
}